// Mapeia erros do Supabase Auth para mensagens em pt-BR.
export function mensagemDeErro(err: unknown): string {
  const msg = err instanceof Error ? err.message : String(err);
  const mapa: Array<[RegExp, string]> = [
    [/invalid login credentials/i, "E-mail ou senha incorretos."],
    [/email not confirmed/i, "Confirme seu e-mail antes de entrar. Verifique sua caixa de entrada."],
    [/user already registered/i, "Já existe uma conta com este e-mail. Tente entrar."],
    [/password should be at least/i, "A senha precisa ter no mínimo 8 caracteres."],
    [/rate limit|too many requests/i, "Muitas tentativas. Aguarde um instante e tente novamente."],
    [/same password/i, "A nova senha precisa ser diferente da atual."],
  ];
  for (const [re, texto] of mapa) {
    if (re.test(msg)) return texto;
  }
  return "Algo deu errado. Tente novamente.";
}
